var map = {
	"./1.jpg": "49c2",
	"./2.jpg": "f8e9",
	"./3.jpg": "c450",
	"./4.jpg": "36bb",
	"./5.jpg": "a512",
	"./6.jpg": "2ed8",
	"./7.jpg": "91d6",
	"./8.jpg": "c0b5",
	"./9.jpg": "1919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8803";